import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CallLogStatus = "All" | "ANSWERED" | "MISSED" | "NO_ANSWER";
export type CallLogDirection = "All" | "OUTBOUND" | "INBOUND";
export type CallLogCategory = "All" | "TELECMI" | "MOBILE_APP" | "CLOUD_TELEPHONY";

export interface CallLogState {
  search: string;
  status: CallLogStatus;
  direction: CallLogDirection;
  category: CallLogCategory;
}

const initialState: CallLogState = {
  search: "",
  status: "All",
  direction: "All",
  category: "All",
};

const callLogSlice = createSlice({
  name: "callLog",
  initialState,
  reducers: {
    setCallLogSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setCallLogStatus(state, action: PayloadAction<CallLogStatus>) {
      state.status = action.payload;
    },
    setCallLogDirection(state, action: PayloadAction<CallLogDirection>) {
      state.direction = action.payload;
    },
    setCallLogCategory(state, action: PayloadAction<CallLogCategory>) {
      state.category = action.payload;
    },
    clearCallLogFilters() {
      return initialState;
    },
  },
});

export const {
  setCallLogSearch,
  setCallLogStatus,
  setCallLogDirection,
  setCallLogCategory,
  clearCallLogFilters,
} = callLogSlice.actions;

export default callLogSlice.reducer;
